import { connect } from 'react-redux';
import { translate } from 'jitsi/base/i18n/functions';
import AbstractButton from 'jitsi/base/toolbox/components/AbstractButton';
import { IconHideCameraOff } from 'jitsi/base/icons/svg';
import { shouldHideCameraOffParticipants, toggleHideCameraOffParticipants, } from 'context/video-grid/functions';
class HideCameraOffButton extends AbstractButton {
    icon = IconHideCameraOff;
    tooltip = 'toolbar.accessibilityLabel.hideCameraOff';
    accessibilityLabel = 'toolbar.accessibilityLabel.hideCameraOff';
    label = 'toolbar.hideCameraOff';
    toggledAccessibilityLabel = 'toolbar.accessibilityLabel.showCameraOff';
    toggledLabel = 'toolbar.accessibilityLabel.showCameraOff';
    toggledTooltip = 'toolbar.showCameraOff';
    constructor(props) {
        super(props);
        this.toggleHideCameraOffParticipants = this.toggleHideCameraOffParticipants.bind(this);
    }
    toggleHideCameraOffParticipants() {
        const { toggleHideCameraOffParticipants, isCurrentlyHidden } = this.props;
        toggleHideCameraOffParticipants(!isCurrentlyHidden);
    }
    _isToggled() {
        return this.props.isCurrentlyHidden;
    }
    _handleClick() {
        return this.toggleHideCameraOffParticipants();
    }
}
const mapStateToProps = (state) => {
    return {
        isCurrentlyHidden: shouldHideCameraOffParticipants(state),
    };
};
const mapDispatchToProps = {
    toggleHideCameraOffParticipants,
};
export default translate(connect(mapStateToProps, mapDispatchToProps)(HideCameraOffButton));
